// auth.interceptor.js

"use strict"

function authInterceptor($window) {
    return {
        request: function(config) {
            config.headers = config.headers || {};
            return config;
        },
        responseError: function(response) {
            switch (response.status) {
                case 401:
                  $window.location.href = '/login';
                  return;
                default:
                    return response;
            }
        }
    };
}

authInterceptor.$inject = ["$window"];

export { authInterceptor };
